// src/pages/PagesUtilisateurs/DashboardUsers/utils/dashboardUser.utils.js

export const isReadFlag = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value !== 0;

  if (typeof value === "string") {
    return value !== "0" && value.toLowerCase() !== "false";
  }

  return Boolean(value);
};

export const formatDateTime = (value) => {
  if (!value) {
    return {
      date: "—",
      time: "",
    };
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return {
      date: "—",
      time: "",
    };
  }

  return {
    date: date.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    }),

    time: date.toLocaleTimeString("fr-FR", {
      hour: "2-digit",
      minute: "2-digit",
    }),
  };
};

export const stripHtml = (value = "") => {
  if (!value) return "";

  return String(value)
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<\/p>/gi, " ")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/\s+/g, " ")
    .trim();
};

export const uniqueIds = (list = []) =>
  Array.from(new Set(list.filter(Boolean)));

export const getTechniqueId = (row) =>
  row?.technique_id ??
  row?.Technique?.id ??
  row?.technique?.id ??
  row?.id_technique ??
  null;

export const getEventId = (row) =>
  row?.event_id ??
  row?.Event?.id ??
  row?.event?.id ??
  row?.id_event ??
  null;

export const getPendingPayments = (rows = []) =>
  (Array.isArray(rows) ? rows : []).filter(
    (row) => String(row?.statut_reglement || "") !== "Réglé",
  );

export const formatEuro = (value) => {
  const amount = Number(value);

  if (!Number.isFinite(amount)) return "—";

  return amount.toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
  });
};